module.exports = __webpack_public_path__ + "static/littlecosyelephant-9b918133667f6f588539d195538a71c2.jpeg";